module.exports = __webpack_public_path__ + "img/answer-c1-3.a858acf6.png";